import { Trans } from "react-i18next";

import util from "utils/utils";

export default function ChallengeAddedToCalendar({ events, ownerChallenge }) {
  return (
    <Trans
      i18nKey="notifications.challengeAddedToCalendarEvent"
      values={{
        events: util.getCalendarEventNames(events),
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
}
